import { render, staticRenderFns } from "./TransportCost.vue?vue&type=template&id=442e5d6b"
import script from "./TransportCost.vue?vue&type=script&lang=ts"
export * from "./TransportCost.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports